'use client';

import NextLink from 'next/link';
import type { ComponentProps, ReactNode } from 'react';
import { useNavigation } from '@/hooks/useNavigation';

interface LinkProps extends Omit<ComponentProps<typeof NextLink>, 'href'> {
  href: string;
  children: ReactNode;
}

export default function Link({ href, children, ...props }: LinkProps) {
  const { getLocalizedPath } = useNavigation();

  const isExternal = href.startsWith('http');

  if (isExternal) {
    return (
      <a href={href} rel='noopener noreferrer' target='_blank' {...props}>
        {children}
      </a>
    );
  }

  const localizedHref = getLocalizedPath(href);
  return (
    <NextLink href={localizedHref} {...props}>
      {children}
    </NextLink>
  );
}
